export const formatNumberWithCommas = (num) => {
  // 2.11.1: safari does not support lookbehind in regex.
  return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, ",");
};
